import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { ModalComponent } from '../shared/modal/modal.component';

@Component({
  selector: 'allbids-submitted-dialog',
  standalone: true,
  imports: [CommonModule, RouterLink, ModalComponent],
  templateUrl: './allbids-submitted-dialog.component.html',
  styleUrl: './allbids-submitted-dialog.component.scss',
})
export class AllBidsSubmittedDialogComponent {
  @Input() active: boolean = false;
  @Output() modalClosed = new EventEmitter<boolean>();

  closeDialog() {
    this.active = false;
    this.modalClosed.emit(this.active);
  }
  submit() {
    this.closeDialog();
  }
}
